export default {
	"lang": "en",
	"page-title": "市場分析",
}